import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
Vue.use(Vuex)

export const store = new Vuex.Store({
    strict: true,
    state: {
        dataSource: [
            { name: "材料", id: "material" },
            { name: "产品", id: "product" },
            { name: "总体要求", id: "task" },
            { name: "完成目标", id: "guid" }
        ],
        status: {},
        tokenState: true
    },
    getters: {
        getters: (state) => {
            return 'getters';
        },
        tokenState: state => {
            return state.tokenState
        },
    },
    mutations: {
        mutations: (state, payload) => {
            return 'mutations';
        },
        getstatus(state, data) {
            state.status = data;
        },
        getTokenState(state, val) {
            state.tokenState = val;
        },
    },
    actions: {
        CommonStatus({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/auth/common/status').then(res => {
                    commit('getstatus', res.data);
                    resolve();
                });
            })

        }
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js